/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'automation-platform.common.cancel-button-title': 'Cancel',
  'automation-platform.common.continue-button-title': 'Continue',
  'automation-platform.common.error-input-character-limit-reached':
    'Provided value exceeds the character limit for the field.',
  'automation-platform.common.error-input-must-not-be-empty': 'Input must not be empty',
  'automation-platform.common.error-input-type-is-not-supported': 'Input type not supported yet',
  'automation-platform.common.error-value-is-not-valid-number': 'The value is not a valid number',
  'automation-platform.common.failure-flag-description': "There was a problem and we couldn't run the automation '{0}'",
  'automation-platform.common.failure-flag-title': 'Oops we ran into a problem',
  'automation-platform.common.input-required-for-action': 'Your input is required to complete this action',
  'automation-platform.common.partial-failure-flag-description':
    "Couldn't run the automation against issues {0}, please ensure you have permission to view these issues",
  'automation-platform.common.success-flag': 'Your automation is in progress',
  'automation-platform.footer.audit-log-item': 'Audit log',
  'automation-platform.footer.create-automation-item': 'Create automation',
  'automation-platform.footer.manage-automations-item': 'Manage automations',
  'automation-platform.manual-rules-empty-state.add-manually-triggered-automation': 'Add manually triggered automation',
  'automation-platform.manual-rules-empty-state.create-automations-button-title':
    'You must be a project admin to create automations',
  'automation-platform.manual-rules-empty-state.empty-state-message-new':
    'Create an automation to perform tasks with the click of a button. Once created, manually triggered automations will appear here.',
  'automation-platform.manual-rules-empty-state.see-templates': 'See templates',
};
